var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Input from '../input';
export var DataTableSaveByEnum;
(function (DataTableSaveByEnum) {
    DataTableSaveByEnum["ENTER"] = "ENTER";
    DataTableSaveByEnum["BLUR"] = "BLUR";
    DataTableSaveByEnum["BACKSPACE"] = "BACKSPACE";
})(DataTableSaveByEnum || (DataTableSaveByEnum = {}));
var DataTableItem = /** @class */ (function (_super) {
    __extends(DataTableItem, _super);
    function DataTableItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyDown = function (e) {
            if (e.key === 'Enter') {
                var inputKey = _this.inputKey.inputRef.current.inputRef.current.value;
                var inputVal = _this.inputValue.inputRef.current.inputRef.current.value;
                _this.props.onSubmitInputItem(inputKey, inputVal, DataTableSaveByEnum.ENTER);
            }
            if (e.key === 'Backspace') {
                if (_this.inputKey.inputRef.current.selectionStart === 0) {
                    // Do something if user press Backspace in empty input
                }
            }
        };
        _this.handleBlur = function () {
            var onSubmitInputItem = _this.props.onSubmitInputItem;
            var inputKey = _this.inputKey.inputRef.current.inputRef.current.value;
            var inputVal = _this.inputValue.inputRef.current.inputRef.current.value;
            onSubmitInputItem(inputKey, inputVal, DataTableSaveByEnum.BLUR);
        };
        _this.inputKey = React.createRef();
        _this.inputValue = React.createRef();
        return _this;
    }
    DataTableItem.prototype.componentDidUpdate = function (prevProps) {
        this.inputKey.inputRef.current.inputRef.current.value = this.props.tuple.key;
        this.inputValue.inputRef.current.inputRef.current.value = this.props.tuple.value;
    };
    DataTableItem.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(Input, { error: this.props.error, defaultValue: this.props.tuple.key, ref: function (ref) { return _this.inputKey = ref; }, onKeyDown: this.handleKeyDown, onBlur: this.handleBlur, autoFocus: false, placeholder: "key", disabled: this.props.disabled ? true : false }),
            React.createElement(Input, { defaultValue: this.props.tuple.value, ref: function (ref) { return _this.inputValue = ref; }, onKeyDown: this.handleKeyDown, onBlur: this.handleBlur, placeholder: "value", disabled: this.props.disabled ? true : false })));
    };
    return DataTableItem;
}(React.Component));
export default DataTableItem;
//# sourceMappingURL=data-table-item.js.map